import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import bg1 from 'assets/img/generic/bg-1.jpg';
import Section from 'components/common/Section';
import React, { useContext } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Typewriter } from 'react-simple-typewriter';
import AppContext from 'context/Context';
import { useTranslation } from 'react-i18next';
import mercadoLibreLogo from 'assets/img/logos/mercadolibre45470890.png';

const MercadoLibreLockup = ({ className = '' }) => (
  <span
    className={`d-inline-flex align-items-center rounded-pill px-2 py-1 ${className}`.trim()}
    style={{ backgroundColor: '#ffe600', color: '#2d3277', gap: '0.45rem' }}
  >
    <img
      src={mercadoLibreLogo}
      alt="Mercado Libre"
      style={{ width: '1.45rem', height: '1.45rem', objectFit: 'contain', borderRadius: '999px', backgroundColor: '#fff', padding: '0.08rem' }}
    />
    <span className="fw-semi-bold text-uppercase" style={{ letterSpacing: '0.04em', fontSize: '0.72rem', lineHeight: 1 }}>
      Mercado Libre
    </span>
  </span>
);

const Hero = () => {
  const {
    config: { isRTL }
  } = useContext(AppContext);
  const { t } = useTranslation();

  return (
    <Section
      className="py-0 overflow-hidden light"
      image={bg1}
      position="center bottom"
      overlay
    >
      <Row className="justify-content-center align-items-center pt-8 pt-lg-10 pb-lg-9 pb-xl-0">
        <Col
          md={11}
          lg={8}
          xl={6}
          className="pb-7 pb-xl-9 text-center text-xl-start"
        >
          <div className="mb-3">
            <MercadoLibreLockup />
          </div>
          <h1 className="text-white fw-light fs-4 fs-lg-5 fs-xl-6">
            {t('LANDING.HERO_TITLE_PREFIX')}{' '}
            <span className="fw-bold">
              <Typewriter
                words={t('LANDING.HERO_WORDS', { returnObjects: true })}
                loop={false}
                cursor={!isRTL ? true : false}
                cursorStyle="|"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </span>
            <br />
            {t('LANDING.HERO_TITLE_SUFFIX')}
          </h1>
          <p className="lead text-white opacity-75 mt-3">
            {t('LANDING.HERO_SUBTITLE')}
          </p>
          <Button
            as={Link}
            variant="light"
            size="lg"
            className="rounded-pill mt-4 fs-0 py-2 px-4 fw-semi-bold d-inline-flex align-items-center"
            to="/login"
          >
            <MercadoLibreLockup className="me-2" />
            {t('LANDING.HERO_CTA')}
            <FontAwesomeIcon icon="chevron-right" className="ms-2 fs--1" />
          </Button>
          <Button
            as={Link}
            variant="outline-light"
            size="lg"
            className="rounded-pill mt-4 ms-3 fs-0 py-2 px-4 border-2"
            to="#features"
          >
            {t('LANDING.HERO_CTA_FEATURES')}
          </Button>
        </Col>
        <Col
          xl={{ span: 5, offset: 1 }}
          className="align-self-end mt-4 mt-xl-0 text-center"
        >
          <div className="py-7">
            <FontAwesomeIcon icon="chart-line" className="text-white opacity-50" style={{ fontSize: '8rem' }} />
            <div className="text-white-50 mt-4 small">
              <FontAwesomeIcon icon={['fab', 'whatsapp']} className="me-2" />
              {t('LANDING.WHATSAPP_COMING_SOON')}
            </div>
          </div>
        </Col>
      </Row>
    </Section>
  );
};

export default Hero;
